import { Upload, FileText, TrendingUp, Check } from "lucide-react";

const steps = [
  {
    number: "01",
    icon: "gabi",
    title: "Viabilidad financiera",
    description: "GABI analiza tu perfil y te da una puntuación real de viabilidad — cuánto puedes permitirte, cómo mejorar tu score y qué ayudas podrías aprovechar.",
  },
  {
    number: "02",
    icon: Upload,
    title: "Búsqueda de vivienda",
    description: "Cuéntale a GABI qué tipo de piso buscas, dónde y con qué presupuesto. Te sugiere viviendas reales que encajan contigo, no con el algoritmo de un portal.",
  },
  {
    number: "03",
    icon: FileText,
    title: "Evaluación de pisos",
    description: "GABI genera informes claros con pros, contras y riesgos detectados. Sabrás si ese piso tiene sentido antes incluso de visitarlo.",
  },
  {
    number: "04",
    icon: Check,
    title: "Visita y decisión",
    description: "Llévate tus informes, checklist y comparativas. Cuando encuentres 'el' piso, GABI te ayuda a decidir con cabeza, no con ansiedad.",
  },
  {
    number: "05",
    icon: TrendingUp,
    title: "Financiación sin drama",
    description: "Compara hipotecas reales, descubre ayudas públicas y si no tienes ahorros suficientes, accede a nuestro modelo de alquiler con opción a compra.",
  },
  {
    number: "06",
    icon: Check,
    title: "Cierre y acompañamiento",
    description: "Todo el proceso, centralizado y claro. Con GABI a tu lado hasta que tengas las llaves en la mano. 🏡",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 relative overflow-hidden scroll-mt-24">
      {/* Background decoration */}
      <div className="absolute top-1/4 -right-20 w-96 h-96 rounded-full bg-primary/10 blur-3xl" />
      <div className="absolute bottom-1/4 -left-20 w-96 h-96 rounded-full bg-accent/10 blur-3xl" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold">
            Comprar tu primera vivienda{" "}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-accent">
              ya no tiene por qué ser un caos
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            6 pasos que no requieren tener un máster en economía.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="relative">
            {/* Connecting line */}
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary via-accent to-primary opacity-20 -translate-x-1/2" />

            <div className="space-y-12 md:space-y-20">
              {steps.map((step, index) => (
                <div
                  key={step.number}
                  className={`flex flex-col md:flex-row items-center gap-8 ${
                    index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                  }`}
                >
                  {/* Content */}
                  <div className={`flex-1 ${index % 2 === 0 ? "md:text-right" : "md:text-left"}`}>
                    <div className="glass p-6 rounded-3xl border border-primary/10 hover:border-primary/30 transition-all duration-300 hover:glow-primary">
                      <div className="space-y-3">
                        <div className={`flex items-center gap-3 ${index % 2 === 0 ? "md:justify-end" : "md:justify-start"}`}>
                          <span className="text-6xl font-black text-primary/20">{step.number}</span>
                        </div>
                        <h3 className="text-2xl font-bold">{step.title}</h3>
                        <p className="text-muted-foreground">{step.description}</p>
                      </div>
                    </div>
                  </div>

                  {/* Icon circle */}
                  <div className="relative flex-shrink-0">
                    <div className="w-20 h-20 rounded-full gradient-primary flex items-center justify-center glow-primary">
                      {step.icon === "gabi" ? (
                        <img 
                          src="/gabi.png" 
                          alt="GABI" 
                          className="w-10 h-10 object-contain"
                        />
                      ) : (
                        <step.icon className="w-10 h-10 text-primary-foreground" />
                      )}
                    </div>
                    {/* Pulse effect */}
                    <div className="absolute inset-0 rounded-full bg-primary/20 animate-ping" />
                  </div>

                  {/* Spacer for alternating layout */}
                  <div className="flex-1 hidden md:block" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
